import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { cropUrl } from '../../services/utils';
export const CropIcon: FC<{
  crop: string;
  className;
}> = observer(({
  crop,
  className
}) => <img src={`/static/assets/crop-icons/${cropUrl(crop)}`} onError={({
  currentTarget
}) => {
  currentTarget.onerror = null; // prevents looping
  currentTarget.src = '/static/assets/crop-icons/generic.svg';
}} className={className}></img>);